import { DOCUMENT } from '@angular/common';
import { Component, inject, Inject, Renderer2 } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UntypedFormControl } from '@angular/forms';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AccountSelectors, CurrentUserSelectors } from '@core/account-data';
import { filterBoolean, trackByIndex } from '@core/common-legacy';
import type { SelectOption } from '@core/user-interface-legacy';
import { RtPlatform, PlatformThemeService } from '@core/user-interface-legacy';

import { ROUTES } from './features/router';

export const AUTH_TOKEN_PLAYGROUND_LS_KEY = 'playground-auth-token';

/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'rt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false,
})
export class AppComponent {
  public readonly routes = ROUTES;

  public store = inject(Store);
  public trackByIndex = trackByIndex;
  public authTokenControl = new UntypedFormControl(
    localStorage.getItem(AUTH_TOKEN_PLAYGROUND_LS_KEY),
  );
  public currentAdmin$ = this.store.select(CurrentUserSelectors.data).pipe(filterBoolean);
  public currentAdmin = toSignal(this.currentAdmin$);
  public currentCompany$ = this.store.select(AccountSelectors.currentCompany);
  public companies$: Observable<SelectOption[]> = this.currentAdmin$.pipe(
    map(currentUser =>
      currentUser!.companies.map(company => ({ label: company.name, value: company.id })),
    ),
  );

  constructor(
    @Inject(DOCUMENT)
    private document: Document,
    private renderer: Renderer2,
    private themeSrvc: PlatformThemeService,
    private platform: RtPlatform,
  ) {
    renderer.addClass(document.body, `browser-${themeSrvc.resolveBrowserClassname()}`);
    platform.resolveEnvironmentClassname().classNames.forEach(className => {
      renderer.addClass(document.body, `platform-${className}`);
    });
  }

  public onCompanySelect(value: number) {
    const url = new URL(window.location.href);
    url.searchParams.append('company_id', `${value}`);
    window.location.replace(url.toString());
  }

  public onAuthTokenApply() {
    localStorage.setItem(AUTH_TOKEN_PLAYGROUND_LS_KEY, this.authTokenControl.value);
    window.location.reload();
  }
}
